import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'

// components
import AccountReupHeader from 'components/shared/ReupHeader'
import FlexibilityText from 'components/shared/Cart/FlexibilityText'

const ReupHeader = props => {
  const {
    account, // via withQuery
    season // via withQuery
  } = props

  return (
    <Box my={4}>
      <AccountReupHeader account={account} season={season} />

      <Typography my={4} variant='h2' align='center'>
        Select Plans
      </Typography>

      <Container>
        <FlexibilityText />
      </Container>
    </Box>
  )
}

export default ReupHeader
